type Product = {
  id?: string
  product_id?: string
  loading_number?: any
  loading_number_id?: string
  old_terminal?: number
  components?: any[]
  wholesaler?: string
  description?: string
  terminal?: number
  preferences?: any[]
  preferred_source: {
    terminal: number
    supplier: number
  }
  alternate_source: {
    terminal: number
    supplier: number
  }
  product: number
  gross_quantity: string
  expected_gross_quantity: string
  additionalPreferences: any[]
}

type PRODUCT_UNIQUES = {
  product: number
  suppliers: number[]
  preferences: any
}

const stringifyProduct = ({
  product,
  suppliers,
  preferences,
}: PRODUCT_UNIQUES) => {
  return JSON.stringify({ product, suppliers, preferences })
}

export const groupProductsByTerminals = (
  products: Product[],
  modify = false
) => {
  const terminalsProducts = {} as any
  // remove products with components
  products = products.flatMap((product) =>
    product.components?.length ? product.components : [product]
  )
  products.sort(
    (a, b) => parseFloat(b.gross_quantity) - parseFloat(a.gross_quantity)
  )

  products.forEach((product: Product) => {
    // if (!product.preferred_source) return
    const term_num =
      product?.preferred_source?.terminal ??
      product?.preferences?.[0]?.terminal?.id ??
      product.terminal
    const terminal = modify ? `_${term_num}` : term_num

    const oldTerminal = product.old_terminal

    const preferences =
      product?.preferences?.map((prefs: any) => ({
        supplier_id:
          (prefs?.loading_number?.id ?? prefs?.loading_number_id) &&
          (prefs?.supplier?.id ?? prefs?.supplier),
        terminal_id: prefs?.terminal?.id ?? term_num,
        loading_number_id:
          ((prefs?.supplier?.id ?? prefs?.supplier) &&
            prefs?.loading_number?.id) ??
          undefined,
        loading_number:
          ((prefs?.supplier?.id ?? prefs.supplier) &&
            prefs.loading_number?.loading_number) ??
          prefs.loading_number,
        wholesaler: prefs.loading_number?.wholesaler ?? prefs.wholesaler,
        description: prefs.loading_number?.description ?? prefs.description,
      })) ?? ([] as any)

    if (product.preferred_source?.terminal || term_num)
      preferences[0] = {
        supplier_id:
          (product.loading_number?.id ?? product.loading_number_id) &&
          product?.preferred_source?.supplier,
        terminal_id: product.preferred_source.terminal ?? term_num,
        loading_number:
          product?.preferred_source?.supplier && product.loading_number,
        loading_number_id:
          product?.preferred_source?.supplier && product.loading_number_id,
        wholesaler: product.wholesaler,
        description: product.description,
      }

    // if there are additional prefs add it to preferences
    const newPrefs = product.additionalPreferences ?? []

    newPrefs.forEach((pref: any) => {
      preferences.push({
        supplier_id:
          typeof pref?.supplier === "object" && "id" in pref?.supplier
            ? pref?.supplier?.id
            : pref.supplier,
        terminal_id:
          typeof pref?.terminal === "object" && "id" in pref?.terminal
            ? pref?.terminal?.id
            : pref.terminal,
        loading_number_id:
          typeof pref?.loading_number === "object" &&
          "id" in pref?.loading_number
            ? pref?.loading_number?.id
            : pref.loading_number,
      })
    })

    const suppliers = [] as any[]
    if (product.preferred_source?.supplier)
      suppliers.push(product.preferred_source.supplier)

    terminalsProducts[terminal] = terminalsProducts[terminal] || []
    // Find product id in this terminal with same suppliers

    terminalsProducts[terminal].push({
      id: product?.id,
      preferences,
      suppliers,
      oldTerminal,
      product: product.product,
      gross_quantity: parseFloat(product.gross_quantity),
      expected_gross_quantity: parseFloat(product.expected_gross_quantity),
    })

    // const index = terminalsProducts[terminal].findIndex(
    //   (added: PRODUCT_UNIQUES) =>
    //     stringifyProduct(added) ===
    //     stringifyProduct({ product: product.product, suppliers, preferences })
    // )

    // if (index > -1) {
    //   terminalsProducts[terminal][index].gross_quantity += parseFloat(
    //     product.gross_quantity
    //   )
    //   terminalsProducts[terminal][index].expected_gross_quantity += parseFloat(
    //     product.expected_gross_quantity
    //   )
    // } else
    //   terminalsProducts[terminal].push({
    //     id: product?.id,
    //     preferences,
    //     suppliers,
    //     oldTerminal,
    //     product: product.product,
    //     gross_quantity: parseFloat(product.gross_quantity),
    //     expected_gross_quantity: parseFloat(product.expected_gross_quantity),
    //   })
  })

  return terminalsProducts
}

export const loadingNumberMapper = (data: any) => {
  const output = {} as {
    [key: number | string]: {
      wholesaler?: string
      description?: string
      loading_number?: string
      loading_number_id?: string
      value: number | string
      label: string
    }
  }
  data.results.forEach((item: any) => {
    let label = ""
    if (item.wholesaler && item.wholesaler !== "-")
      label += `${item.wholesaler} - `
    if (item.description && item.description !== "-")
      label += `${item.description} : `
    if (item.loading_number && item.loading_number !== "-")
      label += `${item.loading_number}`

    if (label.endsWith("- ") || label.endsWith(": ")) label = label.slice(0, -2)

    output[`_${item.id}`] = {
      value: item.id,
      wholesaler: item.wholesaler,
      description: item.description,
      loading_number: item.loading_number,
      loading_number_id: item.id,
      label,
    }
  })

  return output
}
